import React, { Component  } from 'react';
import { withRouter } from 'react-router';
import classNames from 'classnames';
import queryString from 'query-string';
import { Checkbox } from '../../forms';
import './assortment.scss';
import './facet-item.scss';

class Assortments extends Component {
    state = {
        assortments: []
    };

    componentDidMount() {
        this.setState({
            assortments: this.props.assortments
        });
    }

    componentDidUpdate(prevProps) {
        if (prevProps && (prevProps.assortments !== this.props.assortments)) {  
            const { assortments } = this.props;

            const hasMoreFacets = (assortments && assortments[0].facetValues.filter(item => item.count > 0).length) > (this.state.assortments && this.state.assortments[0].facetValues.filter(item => item.count > 0).length);
            this.setState({
                assortments: hasMoreFacets || !this.props.isOpen ? this.props.assortments : this.state.assortments
            });
        }
    }

    render() {
        const { location, submitForm } = this.props;
        const { assortments } = this.state;
        const { assortment } = queryString.parse(location.search);
    
        return  (
            <div className="assortment">
                {assortments && assortments[0] && assortments[0].facetValues.map((m => {
                    return (
                        <label key={`assortments${m.label}`} className={classNames({
                            'facet-item': true,
                            'facet-item--is-visible': m.count > 0,
                            'facet-item--is-disabled': m.count === 0 && (assortment && assortment.indexOf(m.label) > -1),
                        })}>
                            <Checkbox name="assortment" value={m.label} onChange={submitForm} defaultChecked={assortment && assortment.indexOf(m.label) > -1} />
                                <>
                                    <span>{m.label}</span>
                                    <span className="facet-item__count">{m.count}st</span>
                                </>
                        </label>
                    );
                }))}
            </div>
        );
    }
    
};

export default withRouter(Assortments);